"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProtectionCheckbox = ProtectionCheckbox;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const types_1 = require("@src/types");
const RegistrationForm_style_1 = require("./RegistrationForm.style");
function ProtectionCheckbox({ agreementRules, setShowDataProcessingModal, }) {
    const [isInitialized, setIsInitialized] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        setIsInitialized(true);
    }, []);
    if (!isInitialized) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex-row", children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: types_1.CompanyRegistrationFormField.protection, valuePropName: "checked", rules: agreementRules, children: (0, jsx_runtime_1.jsxs)(elements_1.Checkbox, { children: [(0, jsx_runtime_1.jsx)(RegistrationForm_style_1.RedText, { children: "*" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "registration.registration_form.protection" })] }) }), (0, jsx_runtime_1.jsx)(RegistrationForm_style_1.QuestionMarkWrapper, { children: (0, jsx_runtime_1.jsx)(elements_1.QuestionMark, { onClick: () => setShowDataProcessingModal(true) }) })] }));
}
